module.exports = __webpack_public_path__ + "static/media/icons_Bilan quadrant inf‚rieur.a9f58507.svg";